import { Component, Input, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { take } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { Control, NoteSelectTypes, Tab } from './types/control';
import { Note, NotesResponse } from './types/notes.response';
import { APP_Constants } from 'src/app/app.constant';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CoxService } from 'src/app/app-business-object-module/cox.service';
import * as uuid from 'uuid';
import { CustomSnackBarService } from 'src/app/common/snack-bar/snack-bar.service';
import { Modal } from 'src/app/common/modal/modal';
import { ModalService } from 'src/app/common/modal/modal.service';

type AddedNote = {
  UUID: string,
  text: string,
  createdBy: string,
  noteType: string,
  internalOnly: boolean,
  createdOn: string
}

@Component({
    selector: 'app-generic-notes-v3',
    templateUrl: './generic-notes-v3.component.html',
    styleUrls: ['./generic-notes-v3.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GenericNotesV3Component implements OnInit {
  @Input() configData: Control;
  @Input() frmGroup: UntypedFormGroup;

  public notes: Note[] = [];
  public allNotes: Note[] = [];
  public internalOnly = true;
  public internalOnlyDisabled = false;
  public activeTab: { name: string, isAllTab: boolean } = { isAllTab: true } as any;
  public noteTabs: Tab[] = [];
  public noteDropdownTypes: NoteSelectTypes[] = [];

  public currentNoteType = '';
  public currentNoteText = '';
  public addedNotes
  private businessObjectId: string;
  private name = `${localStorage.getItem('firstName')} ${localStorage.getItem('lastName')}`;
  private userName = localStorage.getItem('userName');
  private userRole = localStorage.getItem('userRole');
  public editAccess:boolean = true
  defaultTypeVal: boolean = false
  isShowDefaultType: boolean = false;
  counter: number; // Initial count
  maxLen: number;
  gskOrderNotesResponse:any;
  disableAddNote: boolean = false;
  constructor(private cdRef: ChangeDetectorRef,private _snackBar: CustomSnackBarService,private coxService :CoxService,private appService: AppService, private activeRoute: ActivatedRoute,private modalService: ModalService) { }

  ngOnInit(): void {
    this.maxLen = this.configData?.maxLength
    this.counter = this.configData?.maxLength
    this.editAccess = (this.userRole === 'ClientExternalUser' || this.userRole === 'ClientExternalUserCommercial') ? false : true;

    if (this.configData && 'addNotesInstant' in this.configData && this.configData['addNotesInstant']) {
      this.businessObjectId = this.coxService.getOrderId();
    } 
  
    if(this.configData?.['includeNotesInOrderPayload'] && this.coxService.getOrderId()) {
      this.businessObjectId = this.coxService.getOrderId();
      this.initTabs();
      this.initNoteOptions();
      let contrlVal = this.frmGroup.get(this.configData.name).value || [];
      this.initNotes(null, contrlVal);
      this.cdRef.detectChanges();
    } else if (this.businessObjectId) {
      let notesUrl
      if (this.configData?.enableNotesFromListing) {
        notesUrl = this.configData?.notesUrl + this.businessObjectId;
        notesUrl += '?userId=' + this.userName;
        notesUrl += '&customerCode=' + localStorage.getItem('customerCode') + '&action=fetchOrder';
      } else{
          notesUrl = APP_Constants.COX_ORDER_NOTES_BY_ID + this.businessObjectId;
          notesUrl += '?userId=' + this.userName;
          notesUrl += '&customerCode=' + localStorage.getItem('customerCode');
      }

      this.initTabs();
      this.initNoteOptions();

      this.appService.makeHttpGetRequest(notesUrl).subscribe({
        next: (res: NotesResponse) => {
          if (this.configData?.enableNotesFromListing) {
            this.initNotes(null, res.data.businessObject['orderDetailsStepFour'].orderNotes);
            this.gskOrderNotesResponse = res.data.businessObject;
            if (this.configData?.disableAddNotesForStatus.includes(res?.data?.businessObject?.status)) {
              this.disableAddNote = true;
            }
          } else {
            this.initNotes(res);
          }
          this.cdRef.detectChanges();
        },
        error: (err: any) => this.initEmpty()
      });
    }
    else {
      this.initTabs();
      this.initNoteOptions();
      this.initEmpty();
    }
    sessionStorage.removeItem('isNotesAdd');
  }
  
  valueChange(dynamicCount: string) {
    this.counter = this.maxLen - dynamicCount.length;
  }
  
  initTabs() {
    // Tabs init
    this.noteTabs = this.configData.optionTabs.filter(o => o.roleAccess?.includes(this.userRole));
  }

  initNoteOptions() {
    // Select init
    this.noteDropdownTypes = this.configData.noteSelectTypes.filter(o => o.roleAccess?.includes(this.userRole));
    if(sessionStorage.getItem("coxDefaultOrderNoteType") && sessionStorage.getItem("coxDefaultOrderNoteType") != undefined) {
      this.currentNoteType = sessionStorage.getItem("coxDefaultOrderNoteType");
    } else {
      this.currentNoteType = this.noteDropdownTypes[0]?.value;
    }
     if(this.configData?.['defaultNoteType']){
      this.currentNoteType = this.configData?.['defaultNoteType'];
    }
     this.noteTypeChanged(this.currentNoteType);
  }

  initEmpty() {
    this.allNotes = [];
    this.notes = [];
  }
  disableEmojis(event: any) {
    const regex = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\u24C2|\uD83E[\uDD00-\uDDFF])/g;
    event.target.value = event.target.value.replace(regex, '');

    if (this.currentNoteText) {
      const cleaned = this.currentNoteText.replace(regex, '');
      if (cleaned !== this.currentNoteText) {
        this.currentNoteText = cleaned;
        this.valueChange(cleaned);
      }
    }
    //NCP-14907,14845-start Convert smart quotes,primes and &copy,&cop into empty string due to its trigger WAF/XSS
    const removeText = this.currentNoteText.replace(/[&′″]/g, m => ({ '&': 'and', '′': "'", '″': '"' }[m]!)); 
    if (removeText !== this.currentNoteText) {
      this.currentNoteText = removeText;
      this.valueChange(removeText);
    }
    //NCP-14907,14845-end
  }
  
  initNotes(res?: NotesResponse, data?: Note[]) {
    // Unique note types from response
    // const noteTypes = res.data.businessObject.notes.map(note => note.noteType);
    // this.tabs = noteTypes.filter((elem, index, self) => {
    //   return index === self.indexOf(elem);
    // })

    // Set all notes
    const notes = data ?? [];
    if (this.configData?.['includeNotesInOrderPayload'] || this.configData?.enableNotesFromListing) {
      this.allNotes = notes.filter(note => this.noteTabs.some(t => t.value === note.noteType));
    } else {
      this.allNotes = res.data.businessObject.notes.filter(note => this.noteTabs.some(t => t.value === note.noteType));
    }

    this.allNotes = this.editAccess ? this.allNotes : this.allNotes.filter(note => !note.internalOnly);
    // CP-10350 DE402407 Notes are not displayed in Chronological order
    this.allNotes.sort((a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime());
    this.notes = this.allNotes;
  }

  getTabNotes(tab: string) {
    const tabNotes = this.allNotes.filter(note => note.noteType === tab);
    return tabNotes;
  }

  setTab(index: number, isAllTab: boolean) {
    if (isAllTab) {
      this.activeTab = { isAllTab: true, name: undefined } as any;
      this.setNotes(undefined, true);
    } else {
      this.activeTab = { name: this.noteTabs[index].value, isAllTab: false }
      this.setNotes(this.noteTabs[index].value);
    }
  }

  setNotes(tab: string, useAll = false) {
    // All notes case
    if (useAll) {
      this.notes = this.allNotes;
      return;
    }

    // Regular case
    this.notes = this.getTabNotes(tab);
  }

  transformNoteType(noteType: string): string {
    return noteType === 'dispatch' ? 'transport' :
           noteType === 'followup' ? 'follow-up' :
           noteType === 'dispatch-otm' ? 'Dispatch Notes' :
           noteType;
  }
    
  addNote() {
    const addedNote: AddedNote = {
      UUID: uuid.v4(),
      text: this.currentNoteText,
      internalOnly: this.editAccess ? this.internalOnly : false,
      createdBy: `${localStorage.getItem('firstName')} ${localStorage.getItem('lastName')}`,
      createdOn: this.appService.formatcreatedDateUTC(new Date()),
      noteType: this.currentNoteType,
    }

    let control = this.frmGroup.get('deltaNotes');
    // NCP-11051 Notes are duplicating when the Note and Order are updated.
    if(this.configData?.['includeNotesInOrderPayload']) {
      control = this.frmGroup.get(this.configData.name);
      const currentNotes = control.value || [];
      control.setValue([...currentNotes, addedNote]);
      this.counter = this.configData?.maxLength;
    } else if (!this.configData['addNotesInstant']) {
      if (!control) {
        // Add delta notes to formgroup only when there are new notes
        this.frmGroup.addControl('deltaNotes', new UntypedFormControl());
        control = this.frmGroup.get('deltaNotes');
      }
      
      const currentNotes = control.value || [];
      control.setValue([...currentNotes, addedNote])
      //NCP-13275 Regression Bug-Characters remaining is not resetting to 500 in order create screen while adding notes
      this.counter = this.configData?.maxLength
    }

    if (this.configData?.enableNotesFromListing) {
      let notesUrl
      notesUrl = this.configData.notesUrl + this.businessObjectId;
      notesUrl += '?userId=' + this.userName;
      notesUrl += '&customerCode=' + localStorage.getItem('customerCode') + '&action=fetchOrder';
      this.appService.makeHttpGetRequest(notesUrl).subscribe({
        next: (res: NotesResponse) => {
          if (res?.data?.businessObject['orderDetailsStepFour']?.orderNotes) {
            res?.data?.businessObject['orderDetailsStepFour'].orderNotes.push(addedNote)
          } else {
            res.data.businessObject['orderDetailsStepFour'] = { orderNotes: [] };
            res.data.businessObject['orderDetailsStepFour'].orderNotes.push(addedNote)
          }
          let editNoteUrl
          editNoteUrl = this.configData?.editNoteUrl;
          editNoteUrl += '?userId=' + this.userName;
          editNoteUrl += '&customerCode=' + localStorage.getItem('customerCode') + '&action=updateOrder';

          this.appService.makeHttpPostRequest(editNoteUrl
            , res?.data?.businessObject).subscribe(response => {
              console.log(response)
            })
          this.allNotes = res.data.businessObject['orderDetailsStepFour'].orderNotes
          control = this.frmGroup.get(this.configData.name);
          this.allNotes = this.editAccess ? this.allNotes : this.allNotes.filter(note => !note.internalOnly);
          // CP-10350 DE402407 Notes are not displayed in Chronological order
          this.allNotes.sort((a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime());
          this.notes = this.allNotes;
          const currentNotes = control.value || [];
          control.setValue([...currentNotes, addedNote]);
          this.counter = this.configData?.maxLength;
          this.cdRef.detectChanges();
        },
        error: (err: any) => this.initEmpty()
      });
    }

    this.frmGroup.markAsTouched();
    this.frmGroup.markAsPristine();

    // Clear input
    // this.currentNoteText = '';

    // Add notes to box
    // CP-10350 DE402407 Notes are not displayed in Chronological order
    this.addedNotes = addedNote
    if(!this.configData['addNotesInstant']) {
      this.allNotes.unshift(addedNote)
      if (this.activeTab.name === addedNote.noteType) {
        this.notes.push(addedNote);
      }
    }

    // Re-render only if needed
    

    this.setTab(0, true)
    if (this.configData && 'addNotesInstant' in this.configData && this.configData['addNotesInstant']) {
      this.submitPayloadToApi()
    }
    this.currentNoteText = '';
  }

  submitPayloadToApi() {

    let extractedbusinessObjectId;

    if (this.businessObjectId !== null && typeof this.businessObjectId === 'object') {
      const businessObjectId = this.businessObjectId as object;
      if (Array.isArray(businessObjectId)) {
        extractedbusinessObjectId = businessObjectId[0];
      }
    }
    else {
      extractedbusinessObjectId = this.businessObjectId
    }
    const apiUrl = `${APP_Constants.COX_ORDER_NOTES_BY_ID_FromVerification}?userId=${this.userName}`;
    let payload
    if(this.configData['dhlCustomerType'] =='gskrd'){
       payload = {
        "additionalDetails": {
          "lastUpdatedByUserDisplayName": `${localStorage.getItem('firstName')} ${localStorage.getItem('lastName')}` //Cp-4926
        },
        requestType: "update",
        dhlCustomer: "gskrd",
        orderId: extractedbusinessObjectId,
        notes: [
          {
            UUID: uuid.v4(),
            text: this.currentNoteText,
            createdBy: this.userName || this.name,
            noteType: this.currentNoteType,
            internalOnly: this.editAccess ? this.internalOnly : false,
            createdOn: this.appService.formatcreatedDateUTC(new Date()),
          }
        ]
      };  
    }else{
    payload = {
      "additionalDetails": {
        "lastUpdatedByUserDisplayName": `${localStorage.getItem('firstName')} ${localStorage.getItem('lastName')}` //Cp-4926
      },
      requestType: "update",
      dhlCustomer: "cox",
      orderId: extractedbusinessObjectId,
      notes: [
        {
          UUID: uuid.v4(),
          text: this.currentNoteText,
          createdBy: `${localStorage.getItem('firstName')} ${localStorage.getItem('lastName')}`,
          noteType: this.currentNoteType,
          internalOnly: this.editAccess ? this.internalOnly : false,
          createdOn: this.appService.formatcreatedDateUTC(new Date()),
        }
      ]
    };
  }
    
    this.appService.makeHttpPostRequest(apiUrl, payload)
      .subscribe(
        (response) => {
          this.currentNoteText = '';
          this.counter = this.configData?.maxLength
          this.allNotes.unshift(this.addedNotes)
          if (this.activeTab.name === this.addedNotes.noteType) {
            this.notes.push(this.addedNotes);
          }
          sessionStorage.setItem('isNotesAdd', 'true');
          this._snackBar.open( {orderId:  response['data'].businessObjectId, message: "Successfully updated the notes in  " + extractedbusinessObjectId }, { duration: 20 * 1000 });
          if(this.defaultTypeVal) {
            this.submitDefaultNoteType();
          }
          this.cdRef.detectChanges();
        },
        (error) => {
          this.currentNoteText = '';
          this._snackBar.open( { orderId: extractedbusinessObjectId || '', message: error[0]['message'].statusMessage + " " }, { duration: 20 * 1000 });
        }
      );
      
  }

  // NCP-12909-start Save default note type preference
  submitDefaultNoteType() {
    let payload = {
      queryName: "coxDefaultOrderNoteTypeData",
      queryText: this.currentNoteType
    } 
    let isPresent = (sessionStorage.getItem("coxDefaultOrderNoteType") && sessionStorage.getItem("coxDefaultOrderNoteType") != undefined) ? true : false;
    if(isPresent) {
      let url = APP_Constants.COX_SAVE_FILTER;
      url += '/coxDefaultOrderNoteTypeData?action=COX_ORDER_LISTING';
      url += '&userId=' + localStorage.getItem('userName');
      this.appService.makeHttpPutRequest(url, payload).subscribe(response => {
        sessionStorage.setItem('coxDefaultOrderNoteType', this.currentNoteType);
      }, err => {
        let modal = new Modal({
          action: false, name: 'SavedDefaultNoteType', title: 'Saved Default Note Type', description: err.message, actionButtonText: ''
        });
        this.modalService.createModalBox(modal, err.status);
      });
    } 
    else {
      let url = APP_Constants.COX_SAVE_FILTER;
      url += '?action=COX_ORDER_LISTING';
      url += '&userId=' + localStorage.getItem('userName');
      this.appService.makeHttpPostRequest(url, payload).subscribe(response => {
        console.log("res", response);
        sessionStorage.setItem('coxDefaultOrderNoteType', this.currentNoteType);
      }, err => {
        let modal = new Modal({
          action: false, name: 'SavedDefaultNoteType', title: 'Saved Default Note Type', description: err.message, actionButtonText: ''
        });
        this.modalService.createModalBox(modal, err.status);
      });  
    }
  }
  //NCP-12909-end
  
  noteTypeChanged(value: string, data?) {
    this.currentNoteType = value;
    const noteTypeObj = this.noteDropdownTypes.find(o => o.value === value);

    // Guard
    if (!noteTypeObj) {
      return;
    }
    // NCP-9849 Exceptions for internalOnly toggle for Transport order notes and Pre-dispatch notes
    // ncp-10885 Default Internal Only toggle to OFF for Order Note 
    this.internalOnly = value === "followup" ? true : false;

    // Automatically set internal only value
    if (noteTypeObj.internalOnly?.editable === false) {
      const defaultValue = noteTypeObj.internalOnly.defaultValue;
      this.internalOnly = defaultValue;
      this.internalOnlyDisabled = true;
    } else {
      this.internalOnlyDisabled = false;
    }
    if(data && !this.configData?.['defaultNoteType']) {
      this.isShowDefaultType = true;
    }
    this.defaultTypeVal = false;
  }

  selectedOption() {
    this.defaultTypeVal = !this.defaultTypeVal;
  }
}
